/**
 * web模块的collections里面的类型通过泛型约束来控制
 */
export const collections = {
    /** xenv */
    xenv: true,
    is: true,
    /* isHK */
    isHK: true,
    /** init */
    init: true,
    initV2: true,
    initV3: true,
    /** login */
    login: {
        alimp: true,
        alipay: true,
        cowxmp: true,
        sfcwxmp: true,
        driver: true,
        drwxmp: true,
        gjwxmp: true,
        h5: true,
        kfalimp: true,
        kfdriver: true,
        kfdwxmp: true,
        kfpassenger: true,
        kfwxmp: true,
        mqq: true,
        passenger: true,
        qjwxmp: true,
        thwxmp: true,
        weixin: true,
        wxmp: true,
        dymp: true,
        yxwxmp: true,
        esapp: true,
        hitchapp: true,
        hywxmp: true,
        hydriver: true,
        sfcalimp: true,
        hyalimp: true,
        crwxmp: true,
        cralimp: true,
        eshwxmp: true,
        hwfastapp: true,
        hypassenger: true
    },
    isLogin: {
        alimp: true,
        alipay: true,
        cowxmp: true,
        sfcwxmp: true,
        driver: true,
        drwxmp: true,
        gaswxmp: true,
        gjwxmp: true,
        h5: true,
        kfalimp: true,
        kfdriver: true,
        kfdwxmp: true,
        kfpassenger: true,
        kfwxmp: true,
        mqq: true,
        passenger: true,
        qjwxmp: true,
        qqmp: true,
        thwxmp: true,
        weixin: true,
        wxmp: true,
        dymp: true,
        yxwxmp: true,
        esapp: true,
        hitchapp: true,
        hywxmp: true,
        hydriver: true,
        sfcalimp: true,
        hyalimp: true,
        crwxmp: true,
        cralimp: true,
        eshwxmp: true,
        hwfastapp: true,
        hypassenger: true
    },
    loginCheckPhone: {
        alipay: true,
        mqq: true,
        h5: true,
        weixin: true
    },
    setLoginConfig: {
        alimp: true,
        alipay: true,
        bdmp: true,
        cowxmp: true,
        sfcwxmp: true,
        driver: true,
        drwxmp: true,
        gaswxmp: true,
        gjwxmp: true,
        h5: true,
        kfalimp: true,
        kfdriver: true,
        kfdwxmp: true,
        kfpassenger: true,
        kfwxmp: true,
        mqq: true,
        passenger: true,
        qjwxmp: true,
        qqmp: true,
        thwxmp: true,
        weixin: true,
        wxmp: true,
        dymp: true,
        yxwxmp: true,
        hitchapp: true,
        hywxmp: true,
        hydriver: true,
        sfcalimp: true,
        hyalimp: true,
        crwxmp: true,
        cralimp: true,
        eshwxmp: true,
        hwfastapp: true,
        hypassenger: true
    },
    logout: {
        alipay: true,
        driver: true,
        kfdriver: true,
        mqq: true,
        h5: true,
        weixin: true
    },
    loginSDK: {
        alipay: true,
        driver: true,
        kfdriver: true,
        mqq: true,
        h5: true,
        weixin: true
    },
    /** locate */
    locate: {
        alimp: true,
        alipay: true,
        cowxmp: true,
        sfcwxmp: true,
        driver: true,
        drwxmp: true,
        gaswxmp: true,
        gjwxmp: true,
        h5: true,
        kfalimp: true,
        kfdriver: true,
        kfdwxmp: true,
        kfpassenger: true,
        kfwxmp: true,
        mqq: true,
        passenger: true,
        qjwxmp: true,
        thwxmp: true,
        weixin: true,
        wxmp: true,
        dymp: true,
        yxwxmp: true,
        esapp: true,
        hitchapp: true,
        hywxmp: true,
        hydriver: true,
        sfcalimp: true,
        hyalimp: true,
        crwxmp: true,
        cralimp: true,
        eshwxmp: true,
        hwfastapp: true,
        hypassenger: true
    },
    /** share */
    setShare: {
        alimp: true,
        kfwxmp: true,
        sfcwxmp: true,
        driver: true,
        gaswxmp: true,
        kfdriver: true,
        kfpassenger: true,
        passenger: true,
        qjwxmp: true,
        weixin: true,
        wxmp: true,
        dymp: true,
        yxwxmp: true,
        hitchapp: true,
        hywxmp: true,
        sfcalimp: true,
        hyalimp: true,
        crwxmp: true,
        cralimp: true,
        eshwxmp: true,
        hypassenger: true,
        // hwfastapp: true,
    },
    invokeShare: {
        alimp: true,
        alipay: true,
        driver: true,
        sfcwxmp: true,
        gaswxmp: true,
        kfdriver: true,
        kfpassenger: true,
        kfwxmp: true,
        passenger: true,
        qjwxmp: true,
        weixin: true,
        wxmp: true,
        dymp: true,
        yxwxmp: true,
        hitchapp: true,
        hywxmp: true,
        sfcalimp: true,
        hyalimp: true,
        crwxmp: true,
        cralimp: true,
        eshwxmp: true,
        hypassenger: true,
        hwfastapp: true,
    },
    invokeShareV2: {
        alimp: true,
        // alipay: true,
        // driver: true,
        // sfcwxmp: true,
        // gaswxmp: true,
        // kfdriver: true,
        // kfpassenger: true,
        // kfwxmp: true,
        passenger: true,
        // qjwxmp: true,
        // weixin: true,
        wxmp: true,
        // dymp: true,
        // yxwxmp: true,
        // hitchapp: true,
        // hywxmp: true,
        // sfcalimp: true,
        sfcwxmp: true,
        // hyalimp: true,
        // cralimp: true,
        // eshwxmp: true,
        hwfastapp: true,
    },
    webxInvokeShare: {
        alimp: true,
        // alipay: true,
        // driver: true,
        // sfcwxmp: true,
        // gaswxmp: true,
        // kfdriver: true,
        // kfpassenger: true,
        // kfwxmp: true,
        passenger: true,
        // qjwxmp: true,
        // weixin: true,
        wxmp: true,
        // dymp: true,
        // yxwxmp: true,
        // hitchapp: true,
        // hywxmp: true,
        sfcalimp: true,
        sfcwxmp: true,
        // hyalimp: true,
        // cralimp: true,
        // eshwxmp: true,
        hwfastapp: true,
    },
    /** omega */
    setOmegaConfig: true,
    setOmegaAttrs: true,
    trackEvent: true,
    trackError: true,
    sendXspmScan: true,
    sendXspmClick: true,
    trackPageShow: true,
    trackResourceEvent: true,
    trackResourceExposure: true,
    getOmega: true,
    /** request */
    request: true,
    get: true,
    post: true,
    postEncrypt: true,
    /** webx */
    initProduct: true,
    initProductV2: true,
    initProductV3: true,
    getPageConfig: true,
    getShareConfig: true,
    getShareConfigV2: true,
    getCoverConfig: true,
    getXaidConfig: true,
    getSessionParams: true,
    /** goto */
    goTo: true,
    getGoToParams: true,
    /** subscribe */
    subscribeInit: false,
    tryToSubscribe: false,
    getAlwaysSubscribeStatus: false,
    getCommonSubscribeStatus: false,
    tryToCommonSubscribe: false,
    subscribe: {
        alimp: true,
        cowxmp: true,
        sfcwxmp: true,
        drwxmp: true,
        gjwxmp: true,
        kfdwxmp: true,
        kfwxmp: true,
        qjwxmp: true,
        thwxmp: true,
        wxmp: true,
        yxwxmp: true,
        hywxmp: true,
        eshwxmp: true,
        crwxmp: true,
        cralimp: true,
    },
    /** query */
    build: true,
    buildSearch: true,
    query: true,
    hashBuild: true,
    hashQuery: true,
    parseURL: true,
    /** openid */
    getOpenid: false,
    /** bridge */
    bridge: true,
    dbridge: true,
    kfdbridge: true,
    esappBridge: true,
    hydriverBridge: true,
    weixinReady: {
        cowxmp: true,
        sfcwxmp: true,
        drwxmp: true,
        gjwxmp: true,
        kfdwxmp: true,
        kfwxmp: true,
        qjwxmp: true,
        thwxmp: true,
        weixin: true,
        wxmp: true,
        yxwxmp: true,
        hitchapp: true,
        hywxmp: true,
        crwxmp: true,
        eshwxmp: true
    },
    alipayReady: {
        alimp: true,
        kfalimp: true,
        sfcalimp: true,
        hyalimp: true,
        cralimp: true
    },
    weixinmpReady: {
        cowxmp: true,
        sfcwxmp: true,
        drwxmp: true,
        gjwxmp: true,
        kfdwxmp: true,
        kfwxmp: true,
        qjwxmp: true,
        thwxmp: true,
        wxmp: true,
        yxwxmp: true,
        hitchapp: true,
        hywxmp: true,
        crwxmp: true,
        eshwxmp: true
    },
    alimpReady: {
        alimp: true,
        kfalimp: true,
        sfcalimp: true,
        hyalimp: true,
        cralimp: true
    },
    dympReady: {
        dymp: true,
    },
    mqqReady: {
        qqmp: true
    },
    /** loader */
    loadScript: true,
    sdkReady: true,
    /** saveImg */
    saveImg: {
        driver: true,
        kfdriver: true,
        passenger: true,
        hitchapp: true,
        hydriver: true,
        hypassenger: false
    },
    /** storage */
    storage: true,
    /* getEnvInfo */
    getEnvInfo: true,
    /** userInfo */
    userInit: false,
    reportUserInfo: false,
    queryReportStatus: false,
    /** pay */
    pay: {
        alipay: true,
        alimp: true,
        h5: true,
        weixin: true,
        wxmp: true,
        dymp: true,
        passenger: true,
        kfpassenger: true,
        yxwxmp: true,
        esapp: true,
        driver: true,
        hitchapp: true,
        hywxmp: true,
        qjwxmp: true,
        sfcwxmp: true,
        sfcalimp: true,
        hyalimp: true,
        crwxmp: true,
        cralimp: true,
        hwfastapp: true,
        hypassenger: true
    },
    /** launchApp */
    launchApp: true,
    getLaunchAppInfo: true,
    launchAppWithData: true,
    launchAppInit: true,
    copyCmd: true,
    /* version */
    getVersion: true,
    compareVersion: true,
    /** 非赤兔策略项目预请求(暂定全环境可用) */
    businessInit: true,
    /** resapi **/
    businessResourceLog: true,
    /* initWebxMp */
    initWebxMp: false,
    /* scanCode */
    scanCode: {
        wxmp: true,
        alimp: true,
        passenger: true,
        weixin: true,
    },
    /* addCalendar */
    addCalendar: {
        wxmp: true,
        passenger: true,
    },
    /* isCanUseCalendar */
    isCanUseCalendar: {
        alimp: true,
        wxmp: true,
        passenger: true,
    },
    /* 组件加载器 */
    loadWidget: true,
    updateWidgetResource: true,
    widgetResourceDict: true,
    widgetResourceKeyList: true,
    widgetModules: true
};
